var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-siae-badge';
                    var viewUrl = 'sprite.svg#view-icon-siae-badge';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?icon-siae-badge#icon-siae-badge';
                            viewUrl = 'sprite.svg?icon-siae-badge#view-icon-siae-badge';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 17 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };